import { useMemo } from 'react';
import { useAuth } from './useAuth';
import { hasScope, hasAnyScope, normalizeScopeList } from '../permissions/scopePermissions';

/**
 * Returns memoized scope-checking helpers derived from the current user's scopes.
 *
 * Usage:
 *   const { hasScope, hasAnyScope, userScopes } = useScopePermissions();
 *   {hasScope('members.create') && <CreateButton />}
 */
export default function useScopePermissions() {
  const { user } = useAuth();
  const userScopes = useMemo(() => normalizeScopeList(user?.scopes), [user?.scopes]);

  return useMemo(
    () => ({
      userScopes,
      hasScope:    (requiredScope)  => hasScope(userScopes, requiredScope),
      hasAnyScope: (requiredScopes) => hasAnyScope(userScopes, requiredScopes),
    }),
    [userScopes],
  );
}
